import { TEST_ID_CLASSIC_TEMPLATE_CARD } from 'e2e/playwrightTestIds'
import { useTranslate } from 'react-admin'
import type { ProposalTemplateType } from 'types/proposalTemplate'
import TemplateLibraryCard, { CustomTemplateLibraryCardProps } from './TemplateLibraryCard'

type ClassicTemplateCardProps = CustomTemplateLibraryCardProps & {
  template: ProposalTemplateType
}

const ClassicTemplateCard = (props: ClassicTemplateCardProps) => {
  const translate = useTranslate()
  const cardId = props.id ?? TEST_ID_CLASSIC_TEMPLATE_CARD

  return (
    <TemplateLibraryCard
      id={cardId}
      testId={cardId === TEST_ID_CLASSIC_TEMPLATE_CARD ? TEST_ID_CLASSIC_TEMPLATE_CARD : undefined}
      tag={translate('Classic')}
      header={translate('Scroll')}
      body={translate('Long-form document style "Classic" proposal')}
      imgSrc={`${window.PUBLIC_URL}/images/proposal/template_classic.png`}
      {...props}
    />
  )
}

export default ClassicTemplateCard
